/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const kernel = require('../kernel//kernel')

/**
 * Définit les opérateurs de fonctions à deux variables réelles ou complexes.
 * @type mtg32.Opef2v
 */
const Opef2v = {
  maxi : 0,
  mini : 1,
  gcd : 2,
  lcm : 3,
  ncr : 4,
  npr : 5,
  mod : 6,

  // On garde de la marge pour de futures fonctions réelles
  indicePremiereFonctionComplexe : 64,
  // Début des fonctions complexes
  maxiC : 64,
  miniC : 65,
  gcdC : 66,
  lcmC : 67,
  ncrC : 68,
  nprC : 69,
  modC : 70,

  nomsFoncs2Var : ["maxi","mini","gcd","lcm","ncr","npr","mod"],
  nomsFonctions2Var : function(i) {
    return kernel.getStr(Opef2v.nomsFoncs2Var[i]);
  },

  nomsFoncsComplexes2Var : ["maxi","mini","gcd","lcm","ncr","npr","mod"],
  nomsFonctionsComplexes2Var : function(i) {
    return kernel.getStr(Opef2v.nomsFoncsComplexes2Var[i]);
  },

  syntaxeNomsFoncs2Var : ["infomaxi","infomini","infogcd","infolcm","infoncr","infonpr","infomod"],
  syntaxeNomsFonctions2Var : function(i) {
    return kernel.getStr(Opef2v.syntaxeNomsFoncs2Var[i]);
  },

  syntaxeNomsFoncsComplexes2Var : ["infomaxi","infomini","infogcd","infolcm","infoncr","infonpr","infomod"],
  syntaxeNomsFonctionsComplexes2Var : function(i) {
    return kernel.getStr(Opef2v.syntaxeNomsFoncsComplexes2Var[i]);
  }

};

module.exports = Opef2v
